import { useSelector } from 'react-redux';

import { selectTotalCount, selectFilters, selectSelectedEntitiesCount } from '../../selectors';
import { selectActiveTab } from '../../selectors/activeTab';
import { selectSelectedFolder } from '../../selectors/folders';
import { EEntityType, ETabType } from '../../types/filters';
import { getNewbuildingTextCount, getTextCount } from '../../utils/favoriteEntity';

interface ITopBarCount {
  count: number;
  text: string;
}

export const useTopBarCount = (): ITopBarCount => {
  const total = useSelector(selectTotalCount);
  const selectedFolder = useSelector(selectSelectedFolder);
  const selectedCount = useSelector(selectSelectedEntitiesCount);
  const { favoriteEntityType } = useSelector(selectFilters);
  const { activeTab } = useSelector(selectActiveTab);

  const isNewbuildingTab = favoriteEntityType === EEntityType.Newbuilding || activeTab === ETabType.JK;

  if (selectedCount) {
    return {
      count: selectedCount,
      text: `Выбрано ${selectedCount}${isNewbuildingTab ? ' ЖК' : ''}`,
    };
  }

  let count = total || 0;
  if (selectedFolder && favoriteEntityType !== EEntityType.Newbuilding) {
    count = selectedFolder.offersCount;
  }

  return {
    count: count || 0,
    text: isNewbuildingTab ? getNewbuildingTextCount(count) : getTextCount(count),
  };
};
